<template>
  <div class="match-contact-preview" @click="$emit('click')">
    <div class="preview__avatar">
      <!-- <v-badge v-if="user_data.newMatchId === chatId" color="red" class="chat-badge">
        <template v-slot:badge>
          <span>!</span>
        </template>
        <div class="chat-preview__image-wrapper">
          <div class="chat-preview__avatar" :style="{backgroundImage: 'url(' + picture + ')'}">
            <div v-if="details" class="flag__floating">
              <flag class="flag" :iso="details.nationality" />
            </div>
          </div>
        </div>
      </v-badge> -->
      <div class="chat-preview__image-wrapper">
        <div
          class="chat-preview__avatar"
          :style="{ backgroundImage: 'url(' + picture + ')' }"
        >
          <div v-if="details" class="flag__floating">
            <flag class="flag" :iso="details.nationality" />
          </div>
        </div>
      </div>
    </div>

    <div class="preview__details">
      <b style="word-break: break-word">{{ name }}</b>
      <div v-if="details" style="font-size: 12px">
        {{ detail1 }}<br />
        <span style="display: flex; align-items: center" v-html="detail2"></span>
      </div>
    </div>

    <div v-if="showRemoveButton" class="preview__delete">
      <v-btn
        @click.stop="deleteDialog = true"
        class="connect-question-remove"
        flat
        icon
        color="red"
      >
        <span v-if="showCross">❌</span>
        <v-icon v-else>mdi-undo-variant</v-icon>
      </v-btn>
    </div>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline text-xs-left"
          >Match {{ showCross ? 'ablehnen' : 'zurücknehmen' }}</v-card-title
        >

        <v-card-text class="text-xs-left">
          Möchtest du das Match wirklich {{ showCross ? 'ablehnen' : 'zurücknehmen' }}?
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn :loading="loading" color="red white--text" text @click="deleteMatch"
            >Ja</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { db } from '@/db';

export default {
  name: 'match-preview',

  props: {
    name: {
      type: String,
      default: '',
    },

    picture: {
      type: String,
      default: '',
    },
    msg: {
      type: String,
      default: '',
    },
    chatId: {
      type: String,
      default: '',
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
    },
    details: {
      type: Object,
      default: () => {},
    },
    selectedMatch: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      deleteDialog: false,
      loading: false,
    };
  },

  computed: {
    ...mapState(['user_data', 'userType', 'userMatches']),

    shortMsg() {
      let shortMsg = this.msg;
      if (shortMsg && shortMsg.length > 20) {
        shortMsg = `${shortMsg.slice(0, 20)}...`;
      }
      return shortMsg;
    },

    isScoutOrTeam() {
      return this.userType === 'scouts' || this.userType === 'teams';
    },

    showCross() {
      const forPlayerOrTrainer =
        this.userType === 'users' || this.userType === 'trainers';
      const forTeam =
        this.userType === 'teams' &&
        this.selectedMatch.contactByDetails.type === 'scout';
      return forPlayerOrTrainer || forTeam;
    },

    detail1() {
      if (this.isPlayer) {
        return this.details.player_position;
      }

      if (this.isTeam) {
        return this.details.team_league;
      }

      if (this.isTrainer) {
        return this.details.trainer_type;
      }

      if (this.isScout) {
        return this.details.search_area;
      }

      return '';
    },

    detail2() {
      if (this.isPlayer) {
        return this.details.player_team;
      }

      if (this.isTeam) {
        return `<span class="material-icons" style="font-size: 16px; margin-right: 4px; margin-left: -2px; margin-bottom: 3px">room</span> ${this.details.team_verband}`;
      }

      if (this.isTrainer) {
        return this.details.trainer_team;
      }

      if (this.isScout) {
        return `<span class="material-icons" style="font-size: 16px; margin-right: 4px; margin-left: -2px; margin-bottom: 3px">work_outline</span> ${this.details.working_for}`;
      }
      return '';
    },

    isTrainer() {
      return this.details.type === 'trainer';
    },

    isPlayer() {
      return this.details.type === 'player';
    },

    isTeam() {
      return this.details.type === 'teams';
    },

    isScout() {
      return this.details.type === 'scout';
    },
  },

  methods: {
    async deleteMatch() {
      this.loading = true;
      const matchCreatorId = this.getMatchCreatorId(this.selectedMatch, this.userType);
      const matchCollection = await this.getCollection(
        this.selectedMatch.type,
        this.userType,
        matchCreatorId,
        this.selectedMatch.contactByDetails,
      );

      console.log(this.selectedMatch, matchCollection);
      if (!matchCreatorId || !matchCollection) {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Fehler beim Match löschen',
        });
        this.loading = false;
        this.deleteDialog = false;
        return;
      }

      // get 2nd party of match and update matches

      const contactedBy = await db
        .collection(matchCollection)
        .doc(matchCreatorId)
        .get({ source: 'server' })
        .then((snapshot) => snapshot.data());

      if (!contactedBy) {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Fehler beim Match löschen',
        });
        this.loading = false;
        this.deleteDialog = false;
        return;
      }

      const batch = db.batch();

      // + scout matches > type z kim jest match
      // + team matches > type z kim jest match, jak jest teams znaczy scout z teamem zmaczowal (odwrotnie dane zapisane)
      // + trener/user zawsze odwrotnie zapisane dane, ale kto ten match zrobil?

      // update logged user matches
      const matchesUpdated = this.user_data.matches.filter(
        (matchId) => matchId !== this.chatId,
      );
      const matchesRejected = this.user_data.matches_rejected
        ? this.user_data.matches_rejected
        : [];

      const updatedData = {
        matches: matchesUpdated,
        matches_rejected: [...matchesRejected, this.chatId],
      };

      // update already_matched array
      if (this.user_data.already_matched && this.user_data.already_matched.length) {
        const alreadyMatchedUpdated = this.user_data.already_matched.filter(
          (id) => id !== matchCreatorId,
        );

        updatedData.already_matched = alreadyMatchedUpdated;
        this.user_data.already_matched = alreadyMatchedUpdated;
      }

      // update matchedAndRejected
      const alreadyMatchedRejectedUser = this.user_data.already_matched_and_rejected
        ? this.user_data.already_matched_and_rejected
        : [];

      const alreadyMatchedRejectedUpdated = [
        ...alreadyMatchedRejectedUser,
        matchCreatorId,
      ];

      console.log({ alreadyMatchedRejectedUpdated });
      updatedData.already_matched_and_rejected = alreadyMatchedRejectedUpdated;
      this.user_data.already_matched_and_rejected = alreadyMatchedRejectedUpdated;

      if (this.user_data.newMatchId === this.chatId) {
        this.user_data.newMatchId = null;
        updatedData.newMatchId = null;
      }

      this.user_data.matches = matchesUpdated;

      const refLoggedUser = db.collection(this.userType).doc(this.user_data.id);
      batch.update(refLoggedUser, updatedData);

      // update userMatches in store to hide removed one
      const userMatchesUpdated = this.userMatches.filter(
        (m) => m.chat_id !== this.chatId,
      );
      this.$store.commit('setUserMatches', userMatchesUpdated);

      // get 2nd party of match and update matches

      const contactedByUpdatedMatches = contactedBy.matches.filter(
        (matchId) => matchId !== this.chatId,
      );
      const contactedByMatchesRejected = contactedBy.matches_rejected
        ? contactedBy.matches_rejected
        : [];

      const contactedByUpdatedData = {
        matches: contactedByUpdatedMatches,
        matches_rejected: [...contactedByMatchesRejected, this.chatId],
      };

      if (contactedBy.already_matched && contactedBy.already_matched.length) {
        const alreadyMatchedUpdated = contactedBy.already_matched.filter(
          (id) => id !== this.user_data.id,
        );

        contactedByUpdatedData.already_matched = alreadyMatchedUpdated;
        contactedByUpdatedData.already_matched_and_rejected = this.user_data.id;
      }

      if (contactedBy.newMatchId === this.chatId) {
        contactedByUpdatedData.newMatchId = null;
      }

      const refContacted = db.collection(matchCollection).doc(matchCreatorId);
      batch.update(refContacted, contactedByUpdatedData);

      const refChat = db.collection('matches').doc(this.chatId);
      batch.delete(refChat);

      batch
        .commit()
        .then(() => {
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch((err) => {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Speichern Fehler',
          });
          console.log({ err });
        });
      // await db.collection('messages')
      //   .doc(this.chatId)
      //   .delete();
    },

    async getCollection(matchType, iAm, matchCreatorId, contactByDetails = null) {
      let collection;

      if (iAm === 'teams') {
        if (matchType === 'player') {
          collection = 'users';
        }
        if (matchType === 'teams') {
          collection = 'scouts';
        }
        if (matchType === 'trainer') {
          collection = 'trainers';
        }
      }

      if (iAm === 'scouts') {
        if (matchType === 'player') {
          collection = 'users';
        }
        if (matchType === 'teams') {
          collection = 'teams';
        }
        if (matchType === 'trainer') {
          collection = 'trainers';
        }
      }

      if (iAm === 'users' || iAm === 'trainers') {
        if (contactByDetails) {
          if (contactByDetails.type === 'scout') {
            collection = 'scouts';
          }
          if (contactByDetails.type === 'teams') {
            collection = 'teams';
          }
        } else {
          // old matches, force check if accounts with matchCreatorId exists and where
          const contactedByTeam = await db
            .collection('teams')
            .doc(matchCreatorId)
            .get({ source: 'server' })
            .then((snapshot) => snapshot.data());

          if (contactedByTeam !== undefined) {
            collection = 'teams';
          }

          const contactedByScout = await db
            .collection('scouts')
            .doc(matchCreatorId)
            .get({ source: 'server' })
            .then((snapshot) => snapshot.data());

          if (contactedByScout !== undefined) {
            collection = 'scouts';
          }
        }
      }

      return Promise.resolve(collection);
    },

    getMatchCreatorId(match, iAm) {
      if (iAm === 'teams') {
        if (match.type === 'player' || match.type === 'trainer') return match.player_id;
        if (match.type === 'teams') return match.team_id;
      }

      if (iAm === 'scouts') {
        return match.player_id;
      }

      if (iAm === 'users' || iAm === 'trainers') {
        return match.team_id;
      }

      return null;
    },
  },
};
</script>
